<div
  class="bottom-sheet-arrival-detail-container"
  (click)="close('close-component')"
>
  <div class="bottom-sheet-arrival-detail-line-separator"></div>
  <div
    *ngIf="!isCurrantDay(cardArrivalDetail?.dtArrival); else isToday"
    class="bottom-sheet-arrival-detail-date"
  >
    {{ cardArrivalDetail?.dtArrival | date: "fullDate":"":"pt-BR" }}
  </div>
  <ng-template #isToday
    ><div class="bottom-sheet-arrival-detail-date">Hoje</div></ng-template
  >
  <div class="bottom-sheet-arrival-detail-user-data">
    <img
      class="bottom-sheet-arrival-detail-user-photo"
      src="{{ imgPhoto }}"
      (click)="showImage('close-image')"
    />
    <div
      *ngIf="cardArrivalDetail!.isResponsable"
      class="bottom-sheet-arrival-detail-user-description"
    >
      <div class="bottom-sheet-arrival-detail-user-name">
        {{ cardArrivalDetail!.responsable?.name }}
      </div>
      <div class="bottom-sheet-arrival-detail-user-profile">
        {{ cardArrivalDetail!.authorizedProfiles }}
      </div>
    </div>
    <div
      *ngIf="!cardArrivalDetail!.isResponsable"
      class="bottom-sheet-arrival-detail-user-description-authorized"
    >
      <div class="bottom-sheet-arrival-detail-user-description-authorized-up">
        <div class="bottom-sheet-arrival-detail-authorized-name">
          {{ cardArrivalDetail!.authorized?.name }}
        </div>
        <div class="bottom-sheet-arrival-detail-authorized-profile">
          CPF: {{ cardArrivalDetail!.authorized?.document! | maskCpf }}
        </div>
        <div
          *ngIf="cardArrivalDetail!.authorized?.phone! !== null"
          class="bottom-sheet-arrival-detail-authorized-profile"
        >
          CELULAR: {{ cardArrivalDetail!.authorized?.phone! | phonePipe }}
        </div>
      </div>
      <div class="bottom-sheet-arrival-detail-user-description-authorized-down">
        <div class="bottom-sheet-arrival-detail-responsable">
          Autorizado(a) por
        </div>
        <div class="bottom-sheet-arrival-detail-responsable">
          {{ cardArrivalDetail!.responsable?.name }}
        </div>
        <div class="bottom-sheet-arrival-detail-responsable">
          {{ cardArrivalDetail!.authorizedProfiles }}
        </div>
      </div>
    </div>
  </div>

  <div class="bottom-sheet-arrival-detail-history">
    <div
      class="bottom-sheet-arrival-detail-status"
      *ngFor="let history of cardArrivalDetail!.history; index as i"
    >
      <div
        *ngIf="
          statusDescription(
            history.status,
            history.message,
            cardArrivalDetail!.isResponsable!,
            undefined,
            cardArrivalDetail?.authorizationType
          ) != ''
        "
        [ngClass]="
          history.status === 'UNPREDICTABLE' &&
          cardArrivalDetail!.statusArrival! === 'UNPREDICTABLE'
            ? 'bottom-sheet-arrival-detail-time-icon last-message'
            : 'bottom-sheet-arrival-detail-time-icon'
        "
      >
        <div
          *ngIf="
            sendMessageArrowDirection(cardArrivalDetail!.statusArrival!);
            else sendArrow
          "
        >
          <div class="material-icons">north_east</div>
        </div>
        <ng-template #sendArrow>
          <div class="material-icons">south_west</div>
        </ng-template>
        <div
          *ngIf="dateStr !== ''; else theDate"
          class="bottom-sheet-arrival-detail-time"
        >
          {{ dateStr }}
        </div>
        <ng-template #theDate>
          {{ history.date | date: "shortTime":"":"pt-BR" }}
        </ng-template>
      </div>
      <div
        *ngIf="history.status === 'UNPREDICTABLE'; else notUnpredictable"
        [ngClass]="
          history.status === 'UNPREDICTABLE' &&
          cardArrivalDetail!.statusArrival! === 'UNPREDICTABLE'
            ? 'bottom-sheet-arrival-detail-status-description last-message'
            : 'bottom-sheet-arrival-detail-status-description'
        "
      >
        {{
          statusDescription(
            history.status,
            history.message,
            cardArrivalDetail!.isResponsable!,
            cardArrivalDetail!.history![i - 1].status,
            cardArrivalDetail?.authorizationType
          )
        }}
      </div>
      <ng-template #notUnpredictable>
        <div class="bottom-sheet-arrival-detail-status-description">
          {{
            statusDescription(
              history.status,
              history.message,
              cardArrivalDetail!.isResponsable!,
              undefined,
              cardArrivalDetail?.authorizationType
            )
          }}
        </div>
      </ng-template>
    </div>
    <div
      *ngIf="currentMessage(cardArrivalDetail!.statusArrival!) != ''"
      class="bottom-sheet-arrival-detail-status"
      [ngClass]="
        currentMessage(cardArrivalDetail!.statusArrival!) != ''
          ? 'last-message'
          : ''
      "
    >
      <mat-spinner [diameter]="20"></mat-spinner>
      <div class="bottom-sheet-arrival-detail-status-description">
        {{
          currentMessage(
            cardArrivalDetail!.statusArrival!,
            cardArrivalDetail!.isResponsable
          )
        }}
      </div>
    </div>
  </div>
</div>
